export default {
  PROJECT_UNIT_SET_LOADING: 'PROJECT_UNIT_SET_LOADING',

  PROJECT_UNIT_REQUEST: 'PROJECT_UNIT_REQUEST',
  PROJECT_UNIT_FAILURE: 'PROJECT_UNIT_FAILURE',
  PROJECT_UNIT_SUCCESS: 'PROJECT_UNIT_SUCCESS',

  PROJECT_UNIT_RESET: 'PROJECT_UNIT_RESET',
};
